export const chartColors = {
  default: {
    primary: '#FF9800',
    info: '#209CEE',
    danger: '#FF3860'
  }
}

export const baseChartOptions = {
  maintainAspectRatio: false,
  responsive: true
}

export let chartOptionsMain = {
  ...baseChartOptions,
  tooltips: {
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    bodySpacing: 4,
    xPadding: 12
  },
  scales: {
    yAxes: [{
      barPercentage: 1.6,
      gridLines: {
        drawBorder: false,
        color: 'rgba(66,66,66 ,0.2)',
        zeroLineColor: 'transparent'
      },
      ticks: {
        fontSize: 14,
        padding: 5,
        fontColor: '#212121'
      }
    }],

    xAxes: [{
      barPercentage: 1.6,
      gridLines: {
        drawBorder: false,
        color: 'rgba(66,66,66 ,0.2)',
        zeroLineColor: 'transparent'
      },
      ticks: {
        fontSize: 14,
        padding: 5,
        fontColor: '#212121'
      }
    }]
  }
}
